import React from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from '../../../../components/ui/Drawer';
import CommerceCollectionRuleForm from './CommerceCollectionRuleForm';

/**
 * Regla de cobranza de un comercio en un panel lateral, para editarla sin salir de
 * /admin/cobro (desde "Mayores morosos" o desde el detalle de una nota). Es el mismo
 * formulario de Empresas → Cobranza: la configuración vive en un solo lugar.
 *
 * El formulario solo se monta abierto, así no pide la regla hasta que hace falta.
 *
 * @param {{ open: boolean, onClose: () => void, companyId: string|null,
 *           companyName?: string|null, onSaved?: (view: object) => void }} props
 */
export default function CommerceCollectionRuleDrawer({ open, onClose, companyId, companyName, onSaved }) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      onClose={onClose}
      size="lg"
      title={t('Cobranza de {{name}}', { name: companyName || t('Sin nombre') })}
      description={t('Plazo de vencimiento, recordatorios automáticos y contactos de cobranza del comercio.')}
    >
      {open && companyId && <CommerceCollectionRuleForm companyId={companyId} onSaved={onSaved} />}
    </Drawer>
  );
}
